import type { FormatterMap, ProductRoutesOptions, RouteList } from '@grandvisionhq/frk-routing'
import { createSimpleFormatter } from '@grandvisionhq/frk-routing'
import {
  createAuthFormatters,
  createCheckoutFormatters,
  createMyAccountFormatters,
  productDetailFormatters,
  productListFormatter,
} from '@grandvisionhq/www-next/formatters'

const productRoutesOptions: ProductRoutesOptions = {
  accessories: 'eyecare-and-accessories',
  'contact-lenses': 'contact-lenses',
  frames: 'glasses',
  solutions: 'contact-lenses/solutions',
  sunglasses: 'sunglasses',
}

export const localRouteFormatters: FormatterMap = {
  home: createSimpleFormatter('/'),

  'cart.overview': createSimpleFormatter('cart'),
  'download.invoice': createSimpleFormatter('download-invoice'),
  'appointments.book': createSimpleFormatter('book-appointment'),
  'appointments.cancel': createSimpleFormatter('cancel-appointment'),
  'appointments.reschedule': createSimpleFormatter('reschedule-appointment'),
  'express.checkout.login': createSimpleFormatter('express-user-checkout'),
  ...createMyAccountFormatters(),
  ...createAuthFormatters(),
  'order.confirm': createSimpleFormatter('order/confirm'),
  'express-checkout': createSimpleFormatter('express-checkout'),
  ...createCheckoutFormatters({
    path: 'checkout',
    children: { login: 'login', shipping: 'shipping', overview: 'overview', payment: 'payment' },
  }),
  ...productDetailFormatters(productRoutesOptions),
  ...productListFormatter(productRoutesOptions),
  wishlist: createSimpleFormatter('/wishlist'),
  returns: createSimpleFormatter('/returns-online'),
  'returns.select-items': createSimpleFormatter('/returns-online/select-items'),
  'returns.confirmation': createSimpleFormatter('/returns-online/confirmation'),
}

export const routes: RouteList = [
  ['/', 'home'],

  ['/checkout/login', 'checkout.login'],
  ['/checkout/shipping', 'checkout.shipping'],
  ['/checkout/overview', 'checkout.overview'],
  ['/checkout/payment', 'checkout.payment'],
  ['/api/payment-callback', 'payment.callback'],
  ['/order/confirm', 'order.confirm'],
  ['/express-user-checkout', 'express.checkout.login'],
  ['/express-checkout', 'express-checkout'],

  ['/book-appointment{/*path}', 'appointments.book'],
  ['/reschedule-appointment', 'appointments.reschedule'],
  ['/cancel-appointment', 'appointments.cancel'],
]
